import { render, staticRenderFns } from "./PluginWeglot.vue?vue&type=template&id=1e72e426"
import script from "./PluginWeglot.vue?vue&type=script&lang=js"
export * from "./PluginWeglot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e72e426')) {
      api.createRecord('1e72e426', component.options)
    } else {
      api.reload('1e72e426', component.options)
    }
    module.hot.accept("./PluginWeglot.vue?vue&type=template&id=1e72e426", function () {
      api.rerender('1e72e426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginWeglot.vue"
export default component.exports